

























































































import { library } from '@fortawesome/fontawesome-svg-core';
import { faCode } from '@fortawesome/pro-light-svg-icons';
library.add(faCode);

import BaseTable from '../Common/Mixins/BaseTable.vue';
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DataLoaderParams, Subscription } from '@/types';
import { subsriptionSvc } from '@/services';

@Component({
  name: 'subscriptions-table'
})
export default class SubscriptionsTable extends mixins(BaseTable) {
  title: string | null = 'Subscriptions';
  itemPK: string = 'id';
  sortBy: string = 'created_at';
  dataKey: string = 'subscriptions';
  withDateRange: boolean = false;

  showCode: boolean = false;

  fields: object = {
    name: { label: 'Name' },
    email: { label: 'Email' },
    service: { label: 'Service' },
    plan: { label: 'Plan' },
    version: { label: 'Version' },
    cluster: { label: 'Cluster' },
    url: { label: 'Service URL' },
    status: { label: 'Status' },
    action: { label: 'Action' }
  };

  async dataLoader(params: DataLoaderParams): Promise<any> {
    return await subsriptionSvc.getSubscriptions(params);
  }

  onRowClicked(item: any): void {}
}
